import { RepairsStatuses } from '@api/repairs.api';

export const statusMapper = (
  status: RepairsStatuses,
  language = 'it',
): { label: string; color: string; notifyToClient: boolean } => {
  switch (status) {
    case 'a0_pending':
      return {
        label:
          language === 'de'
            ? 'Warten auf Bestätigung'
            : 'In attesa di conferma',
        color: 'orange',
        notifyToClient: false,
      };
    case 'inserito':
      return {
        label: language === 'de' ? 'Eingetragen' : 'Inserita',
        color: 'blue',
        notifyToClient: true,
      };
    case 'arrivato':
      return {
        label: language === 'de' ? 'Gerät eingetroffen' : 'Macchina arrivata',
        color: 'blue',
        notifyToClient: true,
      };
    case 'consegnato':
      return {
        label: language === 'de' ? 'Gerät zugestellt' : 'Macchina consegnata',
        color: 'blue',
        notifyToClient: true,
      };
    case 'ritiratoPressoCliente':
      return {
        label:
          language === 'de'
            ? 'Beim Kunden abgeholt'
            : 'Macchina ritirata presso il cliente',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inDiagnosi':
      return {
        label: language === 'de' ? 'In Diagnose' : 'In diagnosi',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inAttesaIndicazioniCliente':
      return {
        label:
          language === 'de'
            ? 'Warten auf Rückmeldung vom Kunden'
            : 'In attesa di indicazione dal cliente',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inAttesaApprovazionePreventivo':
      return {
        label:
          language === 'de'
            ? 'Warten auf Freigabe des Kostenvoranschlags'
            : 'In attesa di approvazione preventivo',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inRiparazione':
      return {
        label: language === 'de' ? 'In Reparatur' : 'In riparazione',
        color: 'blue',
        notifyToClient: true,
      };
    case 'speditoARiparatoreEsterno':
      return {
        label:
          language === 'de'
            ? 'An externen Reparaturdienstleister versendet'
            : 'Spedita a riparatore esterno',
        color: 'blue',
        notifyToClient: false,
      };
    case 'inAttesaComponenti':
      return {
        label:
          language === 'de'
            ? 'Warten auf Komponenten'
            : 'In attesa di componenti',
        color: 'blue',
        notifyToClient: false,
      };
    case 'inAttesaInverter':
      return {
        label:
          language === 'de'
            ? 'Warten auf Wechselrichter'
            : 'In attesa di inverter',
        color: 'blue',
        notifyToClient: false,
      };
    case 'inAttesaOffertaFornitoreComponenti':
      return {
        label:
          language === 'de'
            ? 'Warten auf Angebot des Komponentenlieferanten'
            : 'In attesa offerta fornitore componenti',
        color: 'blue',
        notifyToClient: false,
      };
    case 'inAttesaOffertaFornitoreInverter':
      return {
        label:
          language === 'de'
            ? 'Warten auf Angebot des Wechselrichterlieferanten'
            : 'In attesa offerta fornitore inverter',
        color: 'blue',
        notifyToClient: false,
      };
    case 'riparatoInAttesaCollaudo':
      return {
        label:
          language === 'de'
            ? 'Repariert – wartet auf Prüfung'
            : 'Riparata e in attesa di collaudo',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inCollaudo':
      return {
        label: language === 'de' ? 'In Prüfung' : 'In collaudo',
        color: 'blue',
        notifyToClient: true,
      };
    case 'riparazioneECollaudoConclusi':
      return {
        label:
          language === 'de' ? 'Repariert und geprüft' : 'Riparata e collaudata',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inAttesaPagamento':
      return {
        label:
          language === 'de' ? 'Warten auf Zahlung' : 'In attesa di pagamento',
        color: 'blue',
        notifyToClient: true,
      };
    case 'inAttesaRottamazione':
      return {
        label:
          language === 'de'
            ? 'Warten auf Entsorgung'
            : 'In attesa di rottamazione',
        color: 'blue',
        notifyToClient: false,
      };
    case 'prontoPerSpedizione':
      return {
        label: language === 'de' ? 'Versandbereit' : 'Pronta per la spedizione',
        color: 'blue',
        notifyToClient: true,
      };
    case 'prontoPerRitiro':
      return {
        label: language === 'de' ? 'Abholbereit' : 'Pronta per il ritiro',
        color: 'blue',
        notifyToClient: true,
      };
    case 'spedito':
      return {
        label: language === 'de' ? 'Versendet' : 'Spedita',
        color: 'blue',
        notifyToClient: true,
      };
    case 'ritiratoPressoNostraSede':
      return {
        label:
          language === 'de'
            ? 'In unserem Sitz abgeholt'
            : 'Ritirata presso nostra sede',
        color: 'blue',
        notifyToClient: true,
      };
  }
};
